import { adminToolPaths } from '@/constants/adminTool';

export const adminToolRoutes = Object.values(adminToolPaths)
  .map(tab => Object.values(tab).map(path => path))
  .flat();
